module.exports = __webpack_public_path__ + "static/021.thumb-8226ba67788a3f19a24c31481dc74f15.jpg";